import { TActionsWithoutState } from '../Interfaces/TActionsWithoutState';
import { get } from './Actions/get';
import { setCurrent } from './Actions/setCurrent';
import { update } from './Actions/update';

const actions = {
  get,
  setCurrent,
  update
};

export type ISeasonsActions = TActionsWithoutState<typeof actions>;

export default actions;
